var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdminResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01995 0.740182C2.42677 0.402207 2.94055 0.25 3.5 0.25H12.5C13.0365 0.25 13.5479 0.390482 13.9596 0.721078C14.3723 1.05251 14.631 1.53185 14.7393 2.10925L15.8629 7.44662C15.871 7.48472 15.875 7.52356 15.875 7.5625V11.5L15.875 11.5016C15.8733 12.0974 15.6358 12.6683 15.2146 13.0896C14.7933 13.5108 14.2224 13.7483 13.6266 13.75L13.625 13.75H2.375L2.37337 13.75C1.7776 13.7483 1.20672 13.5108 0.785444 13.0896C0.364169 12.6683 0.126732 12.0974 0.125002 11.5016L0.125 11.5V7.5625C0.125 7.52356 0.129044 7.48472 0.137066 7.44662L1.2611 2.10745C1.36849 1.55389 1.6147 1.07685 2.01995 0.740182ZM2.73884 1.60552C2.57404 1.74243 2.43379 1.96664 2.36488 2.32498C2.36426 2.3282 2.36361 2.33142 2.36293 2.33463L1.25 7.62107V11.4991C1.25106 11.7974 1.37002 12.0831 1.58094 12.2941C1.79188 12.505 2.07767 12.624 2.37596 12.625H13.624C13.9223 12.624 14.2081 12.505 14.4191 12.2941C14.63 12.0831 14.749 11.7973 14.75 11.499V7.62107L13.6371 2.33463C13.6361 2.33016 13.6352 2.32567 13.6344 2.32118C13.5661 1.95251 13.4209 1.73129 13.2552 1.59826C13.0868 1.46303 12.8424 1.375 12.5 1.375H3.5C3.14539 1.375 2.90331 1.46889 2.73884 1.60552Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.125 7.5625C0.125 7.25184 0.37684 7 0.6875 7H5.75C6.06066 7 6.3125 7.25184 6.3125 7.5625C6.3125 7.87316 6.06066 8.125 5.75 8.125H0.6875C0.37684 8.125 0.125 7.87316 0.125 7.5625Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6875 7.5625C9.6875 7.25184 9.93934 7 10.25 7H15.3125C15.6232 7 15.875 7.25184 15.875 7.5625C15.875 7.87316 15.6232 8.125 15.3125 8.125H10.25C9.93934 8.125 9.6875 7.87316 9.6875 7.5625Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 7C6.06066 7 6.3125 7.25184 6.3125 7.5625C6.3125 8.01005 6.49029 8.43927 6.80676 8.75574C7.12323 9.07221 7.55245 9.25 8 9.25C8.44755 9.25 8.87677 9.07221 9.19324 8.75574C9.50971 8.43927 9.6875 8.01005 9.6875 7.5625C9.6875 7.25184 9.93934 7 10.25 7C10.5607 7 10.8125 7.25184 10.8125 7.5625C10.8125 8.30842 10.5162 9.02379 9.98874 9.55124C9.46129 10.0787 8.74592 10.375 8 10.375C7.25408 10.375 6.53871 10.0787 6.01126 9.55124C5.48382 9.02379 5.1875 8.30842 5.1875 7.5625C5.1875 7.25184 5.43934 7 5.75 7Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3.0625C3.5 2.75184 3.75184 2.5 4.0625 2.5H11.9375C12.2482 2.5 12.5 2.75184 12.5 3.0625C12.5 3.37316 12.2482 3.625 11.9375 3.625H4.0625C3.75184 3.625 3.5 3.37316 3.5 3.0625Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9375 5.3125C2.9375 5.00184 3.18934 4.75 3.5 4.75H12.5C12.8107 4.75 13.0625 5.00184 13.0625 5.3125C13.0625 5.62316 12.8107 5.875 12.5 5.875H3.5C3.18934 5.875 2.9375 5.62316 2.9375 5.3125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdminResources);
export default __webpack_public_path__ + "static/media/icon-admin-resources.daf8f84739e09f318892c52a9763b6ad.svg";
export { ForwardRef as ReactComponent };